
//const productHandle = 'your-product-handle'; // Replace with your actual product handle

 
        // Function to change quantity
        function changeQuantity(variantId, amount) {
            const input = document.querySelector(`input[data-variant-id='${variantId}']`);
            let currentValue = parseInt(input.value);
            currentValue = isNaN(currentValue) ? 0 : currentValue;
            input.value = Math.max(0, currentValue + amount);
            input.dispatchEvent(new Event('input')); // Trigger the input event to recalculate totals
        }

        // Function to open popup
        async function openPopup(productHandle) {
            document.querySelector("#tdErrMsg").innerText = "";
            document.getElementById('popup').style.display = 'block';
            document.getElementById('overlay').style.display = 'block';
            await fetchProduct(productHandle);
            setCartButtonLabel(); // Set appropriate button label based on cart contents
        }
        // Function to set the appropriate label for the Add/Update button
        function setCartButtonLabel() {
            const variantsContainer = document.getElementById('variantsContainer');
            const inputs = variantsContainer.querySelectorAll('input[type="number"]');
        
            let anyItemsInCart = false;
        
            inputs.forEach(input => {
                if (parseInt(input.value) > 0) {
                    anyItemsInCart = true;
                }
            });
        
            const cartButton = document.getElementById('bulkAddBtn');
            if (anyItemsInCart) {
                cartButton.innerText = 'Update Cart';
            } else {
                cartButton.innerText = 'Add All to Cart';
            }
        }

        // Function to close popup
        function closePopup() {
            document.getElementById('popup').style.display = 'none';
            document.getElementById('overlay').style.display = 'none';

            //Clear existing values.
            const variantsContainer = document.getElementById('variantsContainer');
            variantsContainer.innerHTML = '';
        }

        // Fetch product data by handle
        async function fetchProduct(productHandle) {
            try {
                const response = await fetch(`/products/${productHandle}.js`);
                const product = await response.json();

                // Use product name if only one variant and variant title is "Default Title"
                if (product.variants.length === 1 && product.variants[0].title === "Default Title") {
                    product.variants[0].title = product.title;
                }

                // Display product title
                document.getElementById('productTitle').innerText = product.title;

                // Fetch existing cart data
                const cartResponse = await fetch('/cart.js');
                const cartData = await cartResponse.json();

                // Generate HTML for variants with quantity inputs
                const variantsContainer = document.getElementById('variantsContainer');
                variantsContainer.innerHTML = '';
                product.variants.forEach(variant => {
                    const variantRow = document.createElement('div');
                    variantRow.classList.add('variant-row');

                    const variantPic = document.createElement('div');
                    variantPic.classList.add('variant-pic');
                    const variantImg = document.createElement('img');
                    variantImg.src = product.featured_image; // Assuming same image for variants
                    variantPic.appendChild(variantImg);
                    
                  
                    const variantTitle = document.createElement('div');
                    variantTitle.classList.add('variant-title');
                    const variantText = document.createElement('span');
                    variantText.innerText = variant.title;
                    const skuText = document.createElement('small');
                    skuText.innerText = variant.sku ? "SKU: " + variant.sku : 'No SKU';
                    variantTitle.appendChild(variantText);
                    variantTitle.appendChild(skuText);

                    const variantQty = document.createElement('div');
                    variantQty.classList.add('variant-qty');
                    variantQty.classList.add('quantity-selector');
                    variantQty.classList.add('quantity-selector--product');
                    

                    const minusBtn = document.createElement('button');
                    minusBtn.classList.add('quantity-selector__button');
                    minusBtn.innerHTML = '<svg focusable="false" class="icon icon--minus " viewBox="0 0 10 2" role="presentation"><path d="M10 0v2H0V0z" fill="currentColor"></path></svg>';
                    minusBtn.onclick = () => changeQuantity(variant.id, -1);

                    const qtyInput = document.createElement('input');
                    qtyInput.type = 'number';
                    qtyInput.min = '0';
                    qtyInput.value = '0';
                    qtyInput.dataset.variantId = variant.id;
                    qtyInput.classList.add('quantity-selector__value');
                  
                    const plusBtn = document.createElement('button');
                    plusBtn.classList.add('quantity-selector__button');
                    plusBtn.innerHTML = '<svg focusable="false" class="icon icon--plus " viewBox="0 0 10 10" role="presentation"><path d="M6 4h4v2H6v4H4V6H0V4h4V0h2v4z" fill="currentColor" fill-rule="evenodd"></path></svg>';
                    plusBtn.onclick = () => changeQuantity(variant.id, 1);

                    variantQty.appendChild(minusBtn);
                    variantQty.appendChild(qtyInput);
                    variantQty.appendChild(plusBtn);

                    const variantPrice = document.createElement('div');
                    variantPrice.classList.add('pricing');
                    variantPrice.innerText = variant.price / 100; // No currency symbol

                    const variantTotal = document.createElement('div');
                    variantTotal.classList.add('variant-total');
                    variantTotal.innerText = '0'; // Initial total

                    qtyInput.oninput = () => {
                        variantTotal.innerText = (qtyInput.value * variant.price / 100).toFixed(2);
                        updateSummary();
                    };

                    if (window.innerWidth <= 575) {
                        const variantPicMain = document.createElement('div');
                        variantPicMain.className = 'variant-pic-main';

                        variantPicMain.appendChild(variantPic); // wrap image
                        variantRow.appendChild(variantPicMain);
                    } else {
                        variantRow.appendChild(variantPic); // desktop
                    }

                    if (window.innerWidth <= 575) {
                        const productDataMain = document.createElement('div');
                        productDataMain.className = 'product-data-main';

                        productDataMain.appendChild(variantTitle); // wrap image
                        
                        if (window.innerWidth <= 575) {

                            const productQPT = document.createElement('div');
                            productQPT.className = 'product-QPT';

                            productQPT.appendChild(variantQty);
                            productQPT.appendChild(variantPrice);
                            productQPT.appendChild(variantTotal);

                            productDataMain.appendChild(productQPT);
                        } 
                        
                        variantRow.appendChild(productDataMain);
                    } else {
                        variantRow.appendChild(variantTitle); // desktop
                        variantRow.appendChild(variantQty);
                        variantRow.appendChild(variantPrice);
                        variantRow.appendChild(variantTotal);
                    }

                    variantsContainer.appendChild(variantRow);

                    // Check if this variant is already in the cart
                    const cartItem = cartData.items.find(item => item.variant_id === variant.id);
                    if (cartItem) {
                        qtyInput.value = cartItem.quantity;
                        variantTotal.innerText = (cartItem.quantity * variant.price / 100).toFixed(2);
                    }
                });

                updateSummary();
            } catch (error) {
                console.error('Error fetching product or cart:', error);
            }
        }

// Function to update cart summary
        function updateSummary() {
            const variantsContainer = document.getElementById('variantsContainer');
            const totals = variantsContainer.querySelectorAll('.variant-total');
            const inputs = variantsContainer.querySelectorAll('input[type="number"]');

            let totalItems = 0;
            let subtotal = 0;

            inputs.forEach((input, index) => {
                totalItems += parseInt(input.value) || 0;
                subtotal += parseFloat(totals[index].innerText) || 0;
            });

            document.getElementById('totalItems').innerText = totalItems;
            document.getElementById('subtotal').innerText = `$${subtotal.toFixed(2)}`;
        }

        // Function to handle bulk add to cart or update existing items
        async function bulkAddToCart() {
            document.querySelector("#tdErrMsg").innerText = "";
            const variantsContainer = document.getElementById('variantsContainer');
            const bulkspinner = document.getElementById('bulkspinner');
          
            const inputs = variantsContainer.querySelectorAll('input[type="number"]');
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            const itemsToUpdate = [];
            const itemsToAdd = [];
            let totalQty=0;
            inputs.forEach(input => {
                const qty = parseInt(input.value);
                const variantId = parseInt(input.dataset.variantId);
                totalQty += qty;
                if (qty > 0) {
                    // Check if this variant already exists in the cart
                    const existingCartItem = cartData.items.find(item => item.variant_id === variantId);
        
                    if (existingCartItem) {
                        // If the variant exists in the cart, update its quantity
                        itemsToUpdate.push({
                            line: existingCartItem.key,  // Use the line item key to identify the existing item
                            quantity: qty
                        });
                    } else {
                        // If the variant is not in the cart, add it
                        itemsToAdd.push({
                            id: variantId,
                            quantity: qty
                        });
                    }
                }
            });

            bulkspinner.style.display = "block";
            try {
                // Update quantities for existing items
                for (const item of itemsToUpdate) {
                    const response = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: item.line,
                            quantity: item.quantity
                        })
                    });
        
                    if (!response.ok) {
                        bulkspinner.style.display = "none";
                        throw new Error('Error updating cart items');
                    }
                }
        
                // Add new items to the cart
                if (itemsToAdd.length > 0) {
                    const addResponse = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ items: itemsToAdd })
                    });
        
                    if (!addResponse.ok) {
                        bulkspinner.style.display = "none";
                        throw new Error('Error adding items to cart');
                    }
                }

                  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {
                        quantity: totalQty
                      }
                    }));

                bulkspinner.style.display = "none";
                //alert('Cart updated successfully!');
                closePopup();
            } catch (error) {
                bulkspinner.style.display = "none";
                console.error('Error updating or adding items to cart:', error);
                document.querySelector("#tdErrMsg").innerText =   "There was an error updating the cart. Please try again.";
                //alert('There was an error updating the cart. Please try again.');
            }
        }


(function(){

  // Start here
      // Event listeners for elements with class 'openPopupLink'
      const popupLinks = document.getElementsByClassName('openPopupLink');
      
      for (let i = 0; i < popupLinks.length; i++) {
          popupLinks[i].addEventListener('click', (e) => {
              e.preventDefault();
              var productHandle = e.currentTarget.getAttribute("producthandle");
              openPopup(productHandle);
          });
      }

        //document.getElementById('popupClose').addEventListener('click', closePopup);

        //document.getElementById('bulkAddBtn').addEventListener('click', bulkAddToCart);
  
})();
  